<template>
    <div class="c-activity__followers flex-container">
        <div class="flex-item-pull-left" v-if="!enableEdit">
            <div>
                <div
                    v-if="isFollowing"
                    @mouseover="showUnfollow = true"
                    @mouseleave="showUnfollow = false"
                >
                    <Button
                        v-if="showUnfollow"
                        @click="toggleFollowing"
                        :custom-icon="'icon icon-alarm-bell-off'"
                        ><span>Unfollow</span></Button
                    >
                    <Button
                        v-else
                        @click="toggleFollowing"
                        :custom-icon="'icon icon-alarm-bell'"
                        ><span>Following</span></Button
                    >
                </div>
                <Button
                    v-else
                    @click="toggleFollowing"
                    :custom-icon="'icon icon-alarm-bell'"
                    >Follow</Button
                >
            </div>
        </div>
        <div v-if="!enableEdit" class="flex-item-pull-right flex-container">
            <div
                class="c-activity__avatars flex-container flex-direction-row-reverse"
            >
                <div
                    v-for="user in followersBuffer"
                    :key="user.id"
                    class="c-activity__overlapping-avatar"
                >
                    <Tooltip
                        :content="user.full_name"
                        placement="top"
                        :delay="500"
                    >
                        <user-avatar
                            :avatar="user.avatar"
                            :name="user.first_name"
                            :border="true"
                            :size="'medium'"
                        ></user-avatar>
                    </Tooltip>
                </div>
            </div>
            <div>
                <Button
                    @click="enableEdit = !enableEdit"
                    class="ml-1"
                    :custom-icon="'icon icon-single-neutral-actions-add'"
                ></Button>
            </div>
        </div>
        <div
            v-if="enableEdit"
            class="flex-item-pull-right flex-container flex-align-center"
        >
            <div class="flex-item-grow">
                <Select
                    v-focus
                    @on-select-selected="updateFollower"
                    @on-open-change="handleDropdownOpenChange"
                    :value="followerUserIdsBuffer"
                    filterable
                    multiple
                    placeholder="Add a follower"
                    style="width: 100%;"
                >
                    <Option
                        v-for="user in users"
                        :value="user.id"
                        :key="user.id"
                        >{{ user.first_name + " " + user.last_name }}</Option
                    >
                </Select>
            </div>
            <div class="flex-item-pull-right">
                <Button
                    @click="enableEdit = !enableEdit"
                    class="ml-2"
                    :custom-icon="'icon icon-check-1'"
                ></Button>
            </div>
        </div>
    </div>
</template>

<script>
import focus from "@/js/directives/focus-select";

export default {
    directives: {
        focus: focus,
    },
    props: {
        followers: Array,
        users: Array,
    },
    data() {
        return {
            followersBuffer: this.followers,
            enableEdit: false,
            showUnfollow: false,
        };
    },
    components: {
        UserAvatar: function() {
            return import("@/js/components/partials/user-avatar");
        },
    },
    computed: {
        isFollowing() {
            return _.find(this.followersBuffer, [
                "id",
                this.$store.getters["me/ID"],
            ])
                ? true
                : false;
        },
        followerUserIdsBuffer() {
            return _.map(this.followersBuffer, "id");
        },
    },
    methods: {
        updateFollower(user) {
            this.updateFollowerByUserId(user.value);
        },
        toggleFollowing() {
            this.updateFollowerByUserId(this.$store.getters["me/ID"]);
        },
        updateFollowerByUserId(userId) {
            let selected =
                -1 < _.findIndex(this.followersBuffer, ["id", userId]);
            if (selected) {
                this.$emit("remove", userId);
            } else {
                this.$emit("add", userId);
            }
        },
        handleDropdownOpenChange(isOpen) {
            if (!isOpen) this.enableEdit = !this.enableEdit;
        },
    },
};
</script>
